import React from 'react'
import { graphql } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import { SocialLinks } from '../../components/SocialLinks'
import { ServiceTemplateQuery } from '../../types/graphql'
import { Layout } from '../../components/Layout'

import classNames from 'classnames'
import * as classes from './service.module.scss'

type ServiceProps = {
  data: ServiceTemplateQuery
}

const Service: React.FC<ServiceProps> = ({ data }) => (
  <Layout>
    <div className={classNames(['container', classes.service])}>
      <SocialLinks />
      <div className={classes.main}>
        <h1>{data.strapiService?.title}</h1>
        <ReactMarkdown source={data.strapiService?.content!} />
      </div>
    </div>
  </Layout>
)

export default Service

export const query = graphql`
  query ServiceTemplate($id: String!) {
    strapiService(id: { eq: $id }) {
      content
      title
    }
  }
`
